import { Link } from 'react-router';
import { paths } from '../app/paths';
import { Brand } from '../components/brand';
import { buttonClassName } from '../components/ui/button';
import { useI18n } from '../i18n/i18n';

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-dvh flex-col">
      <header className="px-6 py-4">
        <Brand to={paths.root} wordmark />
      </header>
      <main className="flex flex-1 flex-col items-center justify-center gap-4 px-6 pb-24 text-center">
        <h1 className="text-xl font-semibold">{t('notFound.title')}</h1>
        <Link to={paths.root} className={buttonClassName()}>
          {t('notFound.back')}
        </Link>
      </main>
    </div>
  );
}
